<template>
  <div class="forum-wrapper">
    <v-container fluid class="forum-dashboard-container">
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-card outlined class="forum-card">
            <v-card-title class="text-h5">Delete Post</v-card-title>
            <v-card-text>
              <p>
                Are you sure you want to delete this post by
                <strong>{{ post?.created_by?.username }}</strong>?
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn color="error" @click="deletePost">Delete</v-btn>
              <v-btn variant="text" @click="cancelDelete">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import api from "@/plugins/axios";

export default {
  name: "ForumPostDelete",
  data() {
    return {
      post: null,
    };
  },
  methods: {
    async fetchPost() {
      try {
        const postId = this.$route.params.postId;
        const res = await api.get(`/api/forum-posts/${postId}/`);
        this.post = res.data;
      } catch (error) {
        console.error("Error fetching post:", error);
      }
    },
    async deletePost() {
      try {
        await api.delete(`/api/forum-posts/${this.$route.params.postId}/`);
        this.$router.push(`/forum/${this.post.thread}`);
      } catch (error) {
        console.error("Error deleting post:", error);
      }
    },
    cancelDelete() {
      if (this.post) {
        this.$router.push(`/forum/${this.post.thread}`);
      } else {
        this.$router.push("/forum");
      }
    },
  },
  async created() {
    await this.fetchPost();
  },
  mounted() {
    setTimeout(() => {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }, 200);
  },
};
</script>

<style scoped>
.forum-wrapper {
  overflow: hidden;
}

.forum-dashboard-container {
  background: linear-gradient(to bottom, #fafafa, #e7effa, #d2e3f5);
  padding: 20px;
  min-height: 100vh;
  position: relative;
}

.forum-card {
  background-color: #fff;
  border-radius: 8px;
}
</style>